module.exports = __webpack_public_path__ + "media/images/default/pages/about/main/lock-6970a96d2585a4af92fffb3b4f83ea6d.svg";